<h6 class="d-flex">
    <div>
        <span [innerHtml]="sanitizer.bypassSecurityTrustHtml(check?.label)"></span>
        <span class="text-danger" *ngIf="validateRequired() && editable">*</span>
    </div>
    <ng-container *ngIf="check.tooltip && editable"><span class="text-info ml-auto cursor-pointer" [ngbTooltip]="check.tooltip"><i class="fa fa-info-circle"></i></span></ng-container>
</h6>